import { render, staticRenderFns } from "./CoordsTable.vue?vue&type=template&id=e7c4f032&"
import script from "./CoordsTable.vue?vue&type=script&lang=js&"
export * from "./CoordsTable.vue?vue&type=script&lang=js&"
import style0 from "./CoordsTable.vue?vue&type=style&index=0&id=e7c4f032&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports